import React from 'react';
import {Navigate} from 'react-router-dom';

const RedirectGoogle = () => {
    return <Navigate to='/google5f564e9bf3cda359.html' />;
};

export default RedirectGoogle;
